import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
}
export function SEO({
  title,
  description,
  canonical
}: SEOProps) {
  const siteTitle = 'Khyber Medical Association UK';
  const fullTitle = `${title} | ${siteTitle}`;
  return <Helmet data-id="element-93">
      <title data-id="element-94">{fullTitle}</title>
      <meta name="description" content={description} data-id="element-95" />
      <meta property="og:title" content={fullTitle} data-id="element-96" />
      <meta property="og:description" content={description} data-id="element-97" />
      <meta property="og:type" content="website" data-id="element-98" />
      <meta name="twitter:card" content="summary_large_image" data-id="element-99" />
      <meta name="twitter:title" content={fullTitle} data-id="element-100" />
      <meta name="twitter:description" content={description} data-id="element-101" />
      {canonical && <link rel="canonical" href={canonical} data-id="element-102" />}
    </Helmet>;
}